import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPreviewIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	x: "0px",
	y: "0px",
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n        .arrow-icon-st0{fill:currentColor;}\n        .arrow-icon-st1{stroke:currentColor;}\n    "
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "arrow-icon-st0",
			d: "M 13.74998,2.0907 9.9201,2.08329 V 0 h 7.40398 v 7.40404 h -2.08801 l -0.00744,-3.82828 -7.15997,7.15994 -1.48081,-1.48081 z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "arrow-icon-st1",
			d: "M 6.70557,1.03069 H 1.03069 V 17.43164 H 17.43159 V 11.12612",
			fill: "none",
			strokeWidth: 2.06125,
			strokeLinejoin: "round"
		})
	]
});
export default SvgPreviewIcon;
